module.exports = __webpack_public_path__ + "static/media/i83.ae5821ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i83.svg
// module id = 364
// module chunks = 12